
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import CustomContentLoader from "components/ReuseableCompos/CustomContentLoader";
import MolhamButton from "components/ReuseableCompos/MolhamButton";
import { useAuthContext } from "context/AuthContext";
import { AuthModalContext } from "context/AuthModalContext";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useContext, useRef } from "react";
import { toast } from "react-toastify";
import CreateModal from "../../components/Create/CreateModal";
import { NEXT_URL_PROXY, eventsFallback } from "../../config";
import useHeaderTitleSetter from "../../customHooks/useHeaderTitleSetter";
import useModal from "../../customHooks/useModal";
import useUtilities from "../../customHooks/useUtilities";
import CreateLayout from "../../layout/CreateLayout";
import newEvent from "../../public/lottie/newEvent.json";
import { postData } from "../../utils/postData";
const Create = () => {
    const { t } = useTranslation("common");
    const router = useRouter();
    const { data: utilities } = useUtilities();
    const { donor } = useAuthContext();
    const { handleShowAuthModal, onTabClick, showAuthModal } = useContext(AuthModalContext);
    const title = utilities?.quick_actions.find((item) => item.name.en === "Create a New Event");
    useHeaderTitleSetter({
        title: title?.name[router.locale],
        section: "profile"
    });
    const { showModal: showCreateModal, handleCloseModal: handleCloseCreateModal, handleShowModal: handleShowCreateModal, } = useModal();
    const onCreateButtonClick = () => {
        if (donor) {
            handleShowCreateModal();
        }
        else {
            handleShowAuthModal();
        }
    };
    const ref = useRef(null);
    const { locale } = useRouter();
    const onEventSubmit = async (data) => {
        const fundraiserObj = {
            title: data.title,
            details: data.details,
            date: data.date,
            category_id: +data.category_id,
            preview_image: data.preview_image === ""
                ? // eventsFallback
                    await toDataURI(eventsFallback)
                : data.preview_image,
            private: data.private ? 1 : 0
        };
        let form_data = new FormData();
        for (let key in fundraiserObj) {
            form_data.append(key, fundraiserObj[key]);
        }
        // return;
        try {
            const res = await postData(`${NEXT_URL_PROXY}/targetables/events`, form_data, null, { "Content-type": "multipart/form-data" });
            if (res.data?.error) {
                toast.error(res.data?.error?.message);
                return;
            }
            ref.current.handleReset();
            handleCloseCreateModal();
            router.push(res.data.reference);
            toast.success(t(`event_add_title`));
        }
        catch (err) {
            if (err?.response?.data.status === "Unauthorized") {
                toast.error(err.response.data.status);
                return;
            }
            toast.error(err.response?.data.error?.message);
        }
    };
    const Lottie = dynamic(() => import("lottie-react"), {
        loading: () => (<CustomContentLoader viewBox={`0 0 1200 225`} className="pb-3">
        <rect x="calc(50% - 117px)" y="0" rx="8" ry="8" width="225" height="225"></rect>
      </CustomContentLoader>)
    });
    const isMobile = useMobile("lg");
    const Skeleton = () => {
        return (<CustomContentLoader viewBox={`0 0 ${isMobile ? "400" : "1200"} 145`}>
        <rect x="0" y="0" rx="7" ry="7" width={isMobile ? "400" : "1200"} height="26"/>
        <rect x={isMobile ? "5" : "50"} y="40" rx="7" ry="7" width={isMobile ? "390" : "1100"} height="26"/>
        <rect x={isMobile ? "15" : "100"} y="80" rx="7" ry="7" width={isMobile ? "370" : "1000"} height="26"/>
        <rect x={isMobile ? "30" : "200"} y="120" rx="7" ry="7" width={isMobile ? "340" : "800"} height="26"/>
      </CustomContentLoader>);
    };
    const desc = !utilities ? (isMobile ? (<>
        <div className="mb-y">
          <Skeleton />
        </div>
        <div className="mb-3">
          <Skeleton />
        </div>
        <div className="mb-3">
          <Skeleton />
        </div>
      </>) : (<div className="my-3">
        <Skeleton />
      </div>)) : (utilities?.events_intro[locale]
        .split("<p>")[1]
        .split("</p>")[0]
        .replace("&nbsp;", " "));
    return (
    //SEO in layout
    <div className="py-4">
      <Lottie className="m-auto pb-3" style={{ width: 300 }} animationData={newEvent} loop={true}/>

      {[0].map((_, i) => {
            return (<p key={i} className="text-center fs-18 fw-medium mb-y" style={{
                    lineHeight: 2
                }}>
            {desc}
          </p>);
        })}

      <div className="d-flex justify-content-center">
        <MolhamButton id="event-open-create-btn" startIcon="fe-plus" label={t(`create_event`)} className={isMobile && `w-100`} href={donor ? null : "#login"} onClick={onCreateButtonClick}/>
      </div>
      <CreateModal showCreateModal={showCreateModal} handleCloseCreateModal={handleCloseCreateModal} onFormSubmit={onEventSubmit} action={ref} noHeader noBorder/>
    </div>);
};
export default Create;
Create.Layout = CreateLayout;
const toDataURI = async (url: string) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
            resolve(xhr.response);
        };
        xhr.onerror = () => {
            reject(xhr.statusText);
        };
        xhr.responseType = "blob";
        xhr.open("GET", url);
        xhr.send();
    });
};

    async function __Next_Translate__getStaticProps__1a13f66be22__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/events/create',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66be22__ as getStaticProps }
  